export const validateProfileEditForm = (formData: {
  name: string;
  gender: string;
  region: string;
  yearRoc: string;
  month: string;
  day: string;
  weightKg: string;
  heightCm: string;
}) => {
  const {
    name,
    gender,
    region,
    yearRoc,
    month,
    day,
    weightKg,
    heightCm,
  } = formData;

  if (!name.trim()) return false;
  if (!gender.trim()) return false;
  if (!region.trim()) return false;
  if (!yearRoc.trim()) return false;
  if (!month.trim()) return false;
  if (!day.trim()) return false;
  if (!weightKg.trim()) return false;
  if (!heightCm.trim()) return false;

  return true;
};